import moment from 'moment'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { max, nonNullable } from 'lib/array/arrayUtils'
import { isOrderPast } from 'lib/order/isUpcoming'
import { isItemCancelled } from 'lib/order/orderUtils'

function getOrderAccommodationEndDate(order: App.Order): string | undefined {
  return max(nonNullable(order.items.map(item => item.reservation?.endDate)))
}

function getActiveAccommodationCheckoutDates(order: App.Order): Array<string> {
  return nonNullable([
    ...order.items
      .filter(item => !isItemCancelled(item))
      .map(item => item.reservation?.endDate),
    ...order.bedbankItems
      .filter(item => !isItemCancelled(item))
      .map(item => item.checkOut.format(ISO_DATE_FORMAT)),
  ])
}

/**
 * A stay is past once checkout is today or earlier.
 * Orders without an accommodation checkout fall back to the shared past-order check.
 */
export function isOrderCheckoutTodayOrPast(order: App.Order): boolean {
  const latestCheckout = max(getActiveAccommodationCheckoutDates(order))
  if (!latestCheckout) {
    return isOrderPast(order)
  }

  return moment.utc(latestCheckout, ISO_DATE_FORMAT).isSameOrBefore(moment.utc(), 'day')
}

export default getOrderAccommodationEndDate
